module.exports = __webpack_public_path__ + "img/invoice.3bb4c9fe.svg";